var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUberDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 74,
    viewBox: "0 0 214 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_4405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7886 64.2305C38.8684 64.2305 46.6622 56.4346 46.6622 44.8985V0H57.5721V72.7527H46.7662V65.9967C41.8823 71.0888 35.1283 73.9988 27.5408 73.9988C11.9515 73.9988 0 62.6707 0 45.5292V0.0119346H10.9099V44.8985C10.9099 56.6426 18.5998 64.2305 28.7852 64.2305",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6812 0.00195312H76.1769V26.5043C78.6248 23.9968 81.5506 22.0057 84.7814 20.6487C88.0122 19.2918 91.4823 18.5967 94.9864 18.6044C110.576 18.6044 122.837 30.9725 122.837 46.3546C122.837 61.6327 110.576 73.9991 94.9864 73.9991C91.4655 74.0086 87.9781 73.3149 84.7288 71.9586C81.4796 70.6024 78.5338 68.6108 76.0644 66.1009V72.7495H65.6659L65.6812 0.00195312ZM94.2602 64.7507C104.238 64.7507 112.447 56.5389 112.447 46.3546C112.447 36.0646 104.238 27.9584 94.2602 27.9584C84.1787 27.9584 75.969 36.0646 75.969 46.3546C75.969 56.5389 84.0747 64.7507 94.2602 64.7507Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.225 18.708C169.501 18.708 180.726 30.4522 180.726 46.2502V49.6802H137.603C139.059 58.3064 146.229 64.7504 155.161 64.7504C161.298 64.7504 166.491 62.2546 170.439 56.9545L178.026 62.5666C172.725 69.6345 164.827 73.8947 155.161 73.8947C139.262 73.8947 126.998 62.0466 126.998 46.2502C126.998 31.2841 138.742 18.708 154.227 18.708M137.806 41.3661H170.127C168.361 33.2582 161.813 27.8541 154.019 27.8541C146.225 27.8541 139.678 33.2582 137.806 41.3661Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.889 29.1028C202.03 29.1028 197.042 34.4029 197.042 42.6131V72.7534H186.544V19.7487H196.943V26.3019C199.541 22.0399 203.803 19.3379 209.622 19.3379H213.258V29.1079L208.889 29.1028Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_4405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213.259,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUberDefault);
export default __webpack_public_path__ + "static/media/uber-default.167b0e067b2acd307ab65f2cae14e57b.svg";
export { ForwardRef as ReactComponent };